import { render, staticRenderFns } from "./SelectMaterial.vue?vue&type=template&id=7984371c&scoped=true&lang=pug&"
import script from "./SelectMaterial.vue?vue&type=script&lang=js&"
export * from "./SelectMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SelectMaterial.vue?vue&type=style&index=0&id=7984371c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984371c",
  null
  
)

export default component.exports